// 仅包含已确认的接口固定提示。
// 每项依次为：中文原文、日文、英文。
const entries = [
  ['获取成功', '取得しました', 'Loaded successfully'],
  ['数据获取成功', 'データを取得しました', 'Data loaded successfully'],
  ['获取信息成功', '情報を取得しました', 'Information loaded successfully'],
  ['鉴权错误', '再度ログインしてください', 'Please sign in again'],
  ['旧密码错误', '現在のパスワードが正しくありません', 'The current password is incorrect'],
  ['用户不存在', 'ユーザーが存在しません', 'User not found'],
  ['会员不存在', '会員が存在しません', 'Member not found'],
  ['密码错误', 'パスワードが正しくありません', 'Incorrect password'],
  ['账号被禁用', 'このアカウントは無効になっています', 'This account is disabled'],
  ['登录成功', 'ログインしました', 'Signed in successfully'],
  ['用户名不能存在中文', 'ユーザー名に中国語の文字は使用できません', 'The username cannot contain Chinese characters'],
  ['用户名位数错误', 'ユーザー名の文字数が正しくありません', 'Invalid username length'],
  ['密码位数错误', 'パスワードの文字数が正しくありません', 'Invalid password length'],
  ['邀请码不能为空', '招待コードを入力してください', 'Please enter an invitation code'],
  ['邀请码不存在', '招待コードが存在しません', 'Invitation code not found'],
  ['用户已存在', 'ユーザーはすでに存在します', 'User already exists'],
  ['余额不足', '残高が不足しています', 'Insufficient balance'],
  ['请勿重复提交', '重複して送信しないでください', 'Please do not submit again'],
  ['扣款失败', '残高からの引き落としに失敗しました', 'Failed to debit the balance'],
  ['订单保存失败', '注文を保存できませんでした', 'Failed to save the order'],
  ['分类不存在', 'カテゴリーが存在しません', 'Category not found'],
  ['订单金额异常', '注文金額が正しくありません', 'Invalid order amount'],
  ['打码量不足', '必要な取引量に達していません', 'The required wagering amount has not been reached'],
  ['提现规则异常，请联系客服', '出金設定に問題があります。サポートにお問い合わせください', 'There is a problem with the withdrawal settings. Please contact support'],
  ['当日提现次数已用完', '本日の出金回数の上限に達しました', 'You have reached the daily withdrawal limit'],
  ['提现记录保存失败', '出金申請を保存できませんでした', 'Failed to save the withdrawal request'],
  ['id为空', 'IDが指定されていません', 'Missing ID']
];

export const apiJa = {};
export const apiEn = {};

entries.forEach(([source, japanese, english]) => {
  // 兼容接口原文末尾有无中英文感叹号的情况。
  ['', '！', '!'].forEach(suffix => {
    apiJa[source + suffix] = japanese;
    apiEn[source + suffix] = english;
  });
});
const extraEntries = [
  ['退出成功', 'ログアウトしました', 'Signed out successfully'],
  ['注册成功', '登録が完了しました', 'Registration successful'],
  ['注册失败', '登録に失敗しました', 'Registration failed'],
  ['更换头像成功', 'プロフィール画像を変更しました', 'Profile picture updated'],
  ['更新头像失败', 'プロフィール画像を更新できませんでした', 'Failed to update the profile picture'],
  ['请输入真实姓名后再填写银行卡', '口座を登録する前に、本名を入力してください', 'Please enter your real name before adding a bank card'],
  ['请输入提现密码后再填写银行卡', '口座を登録する前に、出金パスワードを設定してください', 'Please set a withdrawal password before adding a bank card'],
  ['已设置过银行卡', '口座はすでに登録されています', 'A bank card has already been added'],
  ['设置银行卡成功', '口座を登録しました', 'Bank card added successfully'],
  ['设置银行卡失败', '口座を登録できませんでした', 'Failed to add the bank card'],
  ['设置提现密码成功', '出金パスワードを設定しました', 'Withdrawal password set successfully'],
  ['设置提现密码失败', '出金パスワードを設定できませんでした', 'Failed to set the withdrawal password'],
  ['修改密码成功', 'パスワードを変更しました', 'Password changed successfully'],
  ['修改密码失败', 'パスワードを変更できませんでした', 'Failed to change the password'],
  ['请输入真实姓名', '本名を入力してください', 'Please enter your real name'],
  ['设置姓名成功', '氏名を保存しました', 'Name saved successfully'],
  ['设置姓名失败', '氏名を保存できませんでした', 'Failed to save the name'],
  ['设置性别功', '性別を保存しました', 'Gender saved successfully'],
  ['设置性别失败', '性別を保存できませんでした', 'Failed to save the gender'],
  ['金额计算服务不可用', '金額計算サービスを利用できません', 'The amount calculation service is unavailable'],
  ['金额错误', '金額が正しくありません', 'Invalid amount'],
  ['请填写正确的金额', '有効な金額を入力してください', 'Please enter a valid amount'],
  ['参数异常', 'リクエストのパラメーターが正しくありません', 'Invalid request parameters'],
  ['请选择有效选项', '有効な項目を選択してください', 'Please select a valid option'],
  ['选项不能为空或重复', '選択項目を空欄にしたり重複させたりすることはできません', 'Options cannot be empty or duplicated'],
  ['期号规则异常', '期番号の設定に問題があります', 'There is a problem with the period settings'],
  ['选项无效', '選択項目が無効です', 'Invalid option'],
  ['选项或赔率无效', '選択項目またはオッズが無効です', 'Invalid option or odds'],
  ['提交失败，请稍后重试', '送信に失敗しました。しばらくしてから再度お試しください', 'Submission failed. Please try again later'],
  ['打榜成功', '応援を送信しました', 'Support submitted successfully'],
  ['数据不存在', 'データが存在しません', 'Data not found'],
  ['数据获取失败', 'データを取得できませんでした', 'Failed to load data'],
  ['提现失败，请稍后重试', '出金申請に失敗しました。しばらくしてから再度お試しください', 'Withdrawal request failed. Please try again later'],
  ['提现成功', '出金申請を送信しました', 'Withdrawal request submitted']
];

extraEntries.forEach(([source, japanese, english]) => {
  ['', '！', '!'].forEach(suffix => {
    apiJa[source + suffix] = japanese;
    apiEn[source + suffix] = english;
  });
});